import {
  ControlBlocksService,
  Usb_UsbPowerSchedulerMode,
  Usb_UsbSettingsModel,
  Usb_UsbResetPowerModel,
  Usb_UsbSchedulerModeModel,
  Usb_UsbTimeModel,
} from "../api";

export const UsbApi = {

  // Получение параметров USB
  getUsbParams: async (id: string): Promise<Usb_UsbSettingsModel> => {
    return ControlBlocksService.getApiControlBlocksUsbSettings(id);
  },

  // Смена режима USB
  changeUsbMode: async (id: string, mode: Usb_UsbPowerSchedulerMode): Promise<boolean> => {
    const payload: Usb_UsbSchedulerModeModel = { mode };
    await ControlBlocksService.postApiControlBlocksUsbSchedulerMode(id, payload);
    return true;
  },

  // Перезагрузка USB
  resetUsb: async (id: string, seconds: number): Promise<boolean> => {
    const payload: Usb_UsbResetPowerModel = {seconds};
    await ControlBlocksService.postApiControlBlocksUsbPowerReset(id, payload);
    return true;
  },

  // Обновление времени выключения
  updateDisableTime: async (id: string, time: Record<string, string>): Promise<boolean> => {
    const payload = {time: String(time.time ?? "00:00:00")} as unknown as Usb_UsbTimeModel;
    await ControlBlocksService.postApiControlBlocksUsbDisableTime(id, payload);
    return true;
  },

  // Обновление времени включения
  updateEnableTime: async (id: string, time: Record<string, string>): Promise<boolean> => {
    const payload = {time: String(time.time ?? "00:00:00")} as unknown as Usb_UsbTimeModel;
    await ControlBlocksService.postApiControlBlocksUsbEnableTime(id, payload);
    return true;
  },


}
